import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciTooltipsComponent } from './luci-tooltips.component';



@NgModule({
  declarations: [LuciTooltipsComponent],
  exports: [LuciTooltipsComponent],
  imports: [
    CommonModule
  ]
})
export class LuciTooltipsModule { }
